module.exports = __webpack_public_path__ + "media/hero-video-more.2bf4684d.mp4";